<template>
  <q-page class="app-page">
    <div class="app-page-filters">
      <div class="reservation-set" style="flex:1">
        <div class="set-top" style="height:600px;display:flex;overflow-y: scroll;">
          <div class="set-top-left">
            <div class="item-line">
              <div class="item-line-title">预约设置对象：</div>
              <div class="item-line-content">
                <span :class="['check-item', { 'check-item-active': item.checked }]" v-for="(item, index) in locationList" :key="index" @click="checkLocation(index)">
                  {{ item.label }}
                </span>
              </div>
            </div>
            <div class="item-line">
              <div class="item-line-title">预约功能开关：</div>
              <div class="item-line-content">
                <q-radio v-model="globalInfo.state" :val="1" label="开启预约" />
                <q-radio v-model="globalInfo.state" :val="0" label="关闭预约" />
              </div>
            </div>
            <div class="item-line">
              <div class="item-line-title">预约时段设置：</div>
              <div class="item-line-content">
                <a-form-model
                  ref="formRef"
                  :model="globalInfo"
                  :rules="rules"
                  layout="inline"
                >
                <div class="item" v-for="(item, index) in globalInfo.setTimeList" :key="item.timeRangeId">
                  <a-form-model-item style="position: relative;" :prop="'setTimeList.' + index + '.timeRangeId'" :rules="rules.timeRangeId" :labelCol="{span:8}" >
                    <a-select style="width: 200px;margin-right: 10px" v-model="item.timeRangeId" placeholder="请选择预约时段" @change="changeOptions">
                      <a-select-option v-for="item in timeRangeList" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item :prop="'setTimeList.' + index + '.numberOfAvailableReservation'" :rules="rules.numberOfAvailableReservation" :labelCol="{span:8}" >
                    <div class="capcity-info">
                      <a-input style="width: 200px" type="number" v-model.number="item.numberOfAvailableReservation" placeholder="请输入该时段可预约人数"  @change="changeOptions"/>
                      <i-btn v-if="index !== 0" style="margin-left:10px" size="md" color="negative" label="删除" @click="deleteItem(index)" />
                      <i-btn style="margin-left:10px" size="md" color="primary" @click="addItem(item)">新增</i-btn>
                   </div>
                  </a-form-model-item>
                </div>
                </a-form-model>
              </div>
            </div>
            <div class="item-line">
              <div class="item-line-title">临时开闭预约设置：</div>
              <div class="item-line-content" style="display:flex;align-items:center">
                <i-btn style="margin-left:10px" size="md" color="primary" @click="selectDate" :disable="setedRangeList.length === 0">选择日期</i-btn>
                <div v-if="setedRangeList.length === 0" style="color:red;font-size:14px">（配置时间段后方可使用临时开闭预约功能）</div>
              </div>
            </div>
            <div style="text-align:right"><i-btn style="margin-left:10px" size="md" color="action-add" @click="addGlobalSet" :disabled="!dirtyFlag">保存配置</i-btn></div>
          </div>
          <transition name="fade">
            <div class="reservation-set-date-panel" v-if="selectDatePanel">
              <div class="reservation-set-date-panel-title">临时开闭预约时间设置：</div>
              <div class="reservation-set-date-panel-content">
                <div><a-range-picker v-model="rangeDate" @change="onChange" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" :disabledDate="disabledDate" /></div>
                <div>
                  <a-select style="width: 200px;margin-right: 10px" v-model="setInfo.timeRangeId" placeholder="请选择开始时段" @change="(v) => selectRange(v, 'start')">
                    <a-select-option v-for="item in setedRangeList" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select style="width: 200px;margin-right: 10px" v-model="setInfo.endTimeRangeId" placeholder="请选择结束时段" @change="(v) => selectRange(v, 'end')">
                    <a-select-option v-for="item in setedRangeList" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
                <div style="font-size:16px;font-family:blod;text-align:center">
                  {{ rangeText }}
                </div>
                <div style="display:flex;align-items:center">
                  <div class="item-line-title" style="width:auto">预约功能开关：</div>
                  <q-radio v-model="setInfo.state" :val="1" label="开启" />
                  <q-radio v-model="setInfo.state" :val="0" label="关闭" />
                </div>
                <div style="display:flex;align-items:center">
                  <div class="item-line-title" style="width:auto">关闭原因：</div>
                  <a-input style="width: 200px" v-model="setInfo.remark" placeholder="请输入关闭原因" />
                </div>
                <div style="font-size:14px;font-family:blod">
                  注：关闭预约后如有已预约献血者，系统自动发出取消预约提示短信！
                </div>
              </div>
              <div class="reservation-set-date-panel-btn" style="text-align:right">
                <i-btn size="md" color="primary" label="确定" @click="saveLocalSet" :disable="confirmLocalSet"/>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="item-line-title">预约时间配置记录：</div>
    <div class="app-page-main" id="tabMain">
      <div class="set-log">
        <div class="set-log-content">
            <i-table ref="main" :data="main.data" :columns="main.columns" selection="none" :pagination.sync="main.pagination"
            :loading="main.loading" @request="onMainRequest"></i-table>
        </div>
      </div>
    </div>
  </q-page>
</template>
<script>
import { StoreBisDicMixin, AppPageMixin } from '@/lib/mixins'
import utils from '@/lib/utils'

export default {
  mixins: [StoreBisDicMixin, AppPageMixin],
  data () {
    return {
      filters: {
        model: {}
      },
      rules: {
        timeRangeId: [{ required: true, message: '请选择时间段', trigger: 'blur' }],
        numberOfAvailableReservation: [{ required: true, message: '请输入预约人数', trigger: 'change' }]
      },
      dirtyFlag: false,
      rangeDate: [],
      locationList: [],
      state: 1,
      timeRangeList: [],
      selectDatePanel: false,
      setInfo: {
        availableDayStart: '',
        availableDayEnd: '',
        timeRangeId: undefined,
        endTimeRangeId: undefined,
        state: 1,
        remark: ''
      },
      globalInfo: {
        state: 1,
        setTimeList: [
          { timeRangeId: undefined, numberOfAvailableReservation: null }
        ]
      },
      weekMap: {
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        0: '周日'
      },
      main: {
        loading: false,
        data: [],
        columns: [
          { name: 'createTime', label: '时间', sortable: false, format: (val) => utils.formatDateTime(val, 'YYYY-MM-DD HH:mm:ss') },
          { name: 'type', label: '操作', format: (val) => this.getTypeText(val), sortable: false },
          { name: 'object', label: '范围', sortable: false },
          { name: 'remark', label: '原因', sortable: false },
          { name: 'operatorId', label: '操作人', sortable: false, format: (val) => this.$$userNameById(val) }
        ],
        pagination: {
          page: 1,
          rowsPerPage: 10,
          rowsNumber: 0,
          sortBy: '',
          descending: true
        },
        dataFilters: null
      }
    }
  },
  computed: {
    confirmLocalSet () {
      return !(this.setInfo.availableDayStart && this.setInfo.availableDayEnd && this.setInfo.timeRangeId && this.setInfo.endTimeRangeId)
    },
    rangeText () {
      const startRangeName = this.getRangeText(this.setInfo.timeRangeId)
      const endRangeName = this.getRangeText(this.setInfo.endTimeRangeId)
      const startDay = new Date(this.rangeDate[0]).getDay()
      const endDay = new Date(this.rangeDate[1]).getDay()
      return `${this.setInfo.availableDayStart ?? ''} ${startRangeName.split('-')[0] ?? ''} ${this.weekMap[startDay] ?? ''} ${this.setInfo.availableDayEnd ? ' - ' : ''} ${this.setInfo.endTime ?? ''} ${endRangeName.split('-')[1] ?? ''} ${this.weekMap[endDay] ?? ''}`
    },
    locationId () {
      return this.locationList.find(l => l.checked).value
    },
    setedRangeList () {
      const data = []
      this.globalInfo.setTimeList.map(item => {
        console.log(item)
        const findItem = this.timeRangeList.find(t => t.value === item.timeRangeId)
        console.log(findItem)
        if (findItem) {
          data.push({
            value: item.timeRangeId,
            label: findItem.label,
            sort: findItem.sort
          })
        }
      })
      return data
    }
  },
  watch: {
    'globalInfo.state': {
      handler (newVal, oldVal) {
        this.dirtyFlag = true
      }
    }
  },
  async mounted () {
    await this.getTimeRangeDic()
    await this.getLocation()
    this.search()
    this.getGlobalSet()
    this.getTimeRange()
  },
  methods: {
    disabledDate (currentDate) {
      if (currentDate && currentDate < new Date()) {
        return true
      } else {
        return false
      }
    },
    selectRange (value, type) {
      if (value && this.setInfo.availableDayStart === this.setInfo.availableDayEnd) {
        const currentSort = this.setedRangeList.find(s => s.value === value).sort
        if (type === 'start') {
          if (this.setInfo.endTimeRangeId) {
            const endSort = this.setedRangeList.find(s => s.value === this.setInfo.endTimeRangeId).sort
            if (currentSort > endSort) {
              this.$q.notify({ type: 'warning', message: '开始时间不能大于结束时间' })
              this.setInfo.timeRangeId = undefined
            }
          }
        } else if (type === 'end') {
          if (this.setInfo.timeRangeId) {
            const startSort = this.setedRangeList.find(s => s.value === this.setInfo.timeRangeId).sort
            if (currentSort < startSort) {
              this.$q.notify({ type: 'warning', message: '结束时间必须大于或等于开始时间' })
              this.setInfo.endTimeRangeId = undefined
            }
          }
        }
      }
    },
    changeOptions (v) {
      this.dirtyFlag = true
    },
    onMainRequest ({ pagination }) {
      this.search({
        filters: this.main.dataFilters,
        pagination: pagination
      })
    },
    async getGlobalSet () {
      const globalResult = await this.$$api.bis.get(`/collectPoint/${this.locationId}`)
      this.globalInfo.state = globalResult.data.openReservation
    },
    async getTimeRange () {
      const globalTimeRangeResult = await this.$$api.bis.get(`dic/getTimeRange?collectPointId=${this.locationId}`)
      this.globalInfo.setTimeList = []
      if (globalTimeRangeResult.data.length > 0) {
        globalTimeRangeResult.data.sort((a, b) => a.sort - b.sort).map(g => {
          this.globalInfo.setTimeList.push({
            timeRangeId: g.id,
            numberOfAvailableReservation: g.numberOfAvailableReservation
          })
        })
      } else {
        this.globalInfo.setTimeList = [
          { timeRangeId: undefined, numberOfAvailableReservation: null }
        ]
      }
    },
    async addGlobalSet () {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          const params = {
            state: this.globalInfo.state,
            collectPointId: this.locationId,
            reservationList: this.globalInfo.setTimeList.filter(g => g.timeRangeId)
          }
          const result = await this.$$api.bis.put('/reservation/', params)
          result.notifyIfFail()
          if (result.success) {
            this.$q.notify('保存成功！')
            this.getGlobalSet()
            this.getTimeRange()
            this.dirtyFlag = false
          }
        } else {
          console.log(valid)
        }
      })
    },
    async saveLocalSet () {
      // 保存局部配置时，先判断全局是否有修改，有的话先配置全局
      if (this.dirtyFlag) {
        await this.addGlobalSet()
      }
      const params = {
        ...this.setInfo,
        collectPointId: this.locationId
      }
      const result = await this.$$api.bis.post('/reservation/', params)
      result.notifyIfFail()
      if (result.success) {
        this.selectDatePanel = false
        this.search()
      }
    },
    getTypeText (val) {
      switch (val) {
        case 1:
          return '开启预约'
        case 2:
          return '关闭预约'
        case 3:
          return '短时开启预约'
        case 4:
          return '短时关闭预约'
        default:
          return ''
      }
    },
    async search (searchParams) {
      const mainParams = this.buildMainParams(searchParams)
      this.main.loading = true
      const logResult = await this.$$api.bis.get(`reservation/settingRecords?pageSize=${mainParams.page.pageSize}&pageNum=${mainParams.page.pageNum}&collectPointId=${this.locationId}`)
      this.main.loading = false
      logResult.data = {
        data: logResult.data.data,
        pageNum: mainParams.page.pageNum,
        pageTotal: logResult.data.total
      }
      this.updateMain(mainParams, logResult)
    },
    getRangeText (id) {
      const findItem = this.setedRangeList.find(t => t.value === id)
      if (findItem) {
        return findItem.label
      } else {
        return ''
      }
    },
    onChange (v) {
      console.log(v)
      this.setInfo.availableDayStart = v[0]
      this.setInfo.availableDayEnd = v[1]
    },
    checkLocation (index) {
      this.locationList.map(l => {
        l.checked = false
      })
      this.locationList[index].checked = true
      this.getGlobalSet()
      this.getTimeRange()
      this.main.pagination.page = 1
      this.search()
    },
    async getLocation () {
      const locationResult = await this.$$api.bis.get('collectPoint/pageEx?pageSize=999&pageNum=1&dataOwnerId=1&state=1')
      this.locationList = locationResult.data.data.map(item => {
        return {
          label: item.name,
          value: item.id,
          checked: false
        }
      })
      this.locationList[0].checked = true
    },
    async getTimeRangeDic () {
      const dicResult = await this.$$api.bis.get('dic/getByType?type=collect_time_range')
      if (dicResult.data.length > 0) {
        this.timeRangeList = dicResult.data.sort((a, b) => a.sort - b.sort).map(item => {
          return {
            label: item.text,
            value: item.id,
            sort: item.sort
          }
        })
      }
    },
    selectDate () {
      this.selectDatePanel = true
    },
    addItem (item) {
      this.globalInfo.setTimeList.push(
        { timeRangeId: undefined, numberOfAvailableReservation: null }
      )
    },
    deleteItem (index) {
      this.globalInfo.setTimeList.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.reservation-set {
  padding: 20px;
  .item-line {
    display: flex;
    margin-bottom: 40px;
    align-items: baseline;
    .item-line-content {
      flex: 1;
      .check-item {
        margin-right: 20px;
        display: inline-block;
        padding: 5px 20px;
        border: 1px solid #ccc;
        background-color: #fff;
        border-radius: 5px;
        font-family: blod;
        font-size: 16px
      }
      .check-item-active {
        background-color: #2470FF;
        color: #fff;
        border: 0
      }
      .check-item:hover {
        cursor: pointer
      }
      .item {
        display: flex;
        margin-bottom: 10px;
      }
    }
  }
}
.item-line-title {
  font-weight: 700;
  width: 200px;
  text-align: right;
  margin-right: 10px;
}
.reservation-set-date-panel {
  width: 500px;
  padding: 20px;
  background-color:#fff;
  height:550px;
  margin: 20px;
  border-radius:20px;
  margin-top: 0
}
.reservation-set-date-panel-content > div {
    margin: 30px 0
}
.reservation-set-date-panel-title {
    font-size: 16px;
    font-family: blod;
    color: #000;
    padding: 20px 0
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
